import "./formEnableDropdown.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { PropTypeShapes } from "../../types";
import FormButton from "./FormButton";
import FormDropdown, { renderOptionLabel } from "./FormDropdown";
import { renderOptionIcon } from "./FormDropdownMenu";

const getStaticDropdown = (option, centerLabel) => {
  return (
    <div className="dropdown">
      <div className={`dropdownControl static`}>
        {option ? renderOptionIcon(option) : null}
        <div className="dropdownText">
          <div className={`dropdownLabel ${centerLabel ? "centered" : ""}`}>{renderOptionLabel(option)}</div>
        </div>
      </div>
    </div>
  );
};

class FormEnableDropdown extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { isEnabled: false, showMenu: false };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onDropdownChange = this.onDropdownChange.bind(this);
    this.setEnabled = this.setEnabled.bind(this);
  }

  onButtonClick() {
    this.setEnabled(!this.state.isEnabled);
  }

  onDropdownChange(optId) {
    this.props.onChange(optId);
    this.setEnabled(false);
  }

  setEnabled(value) {
    const { isEnabled } = this.state;
    if (isEnabled !== value) {
      this.setState({ isEnabled: value, showMenu: value });
    }
    const { onToggleMenu } = this.props;
    if (onToggleMenu) {
      onToggleMenu(value);
    }
  }

  render() {
    const { disabled, options, value, centerLabel } = this.props;
    const { isEnabled, showMenu } = this.state;
    const selectedOption = this.props.options.find(val => val.value === this.props.value);

    return (
      <div className={`formEnableDropdown ${disabled ? "disabled" : ""}`}>
        {isEnabled ? (
          <FormDropdown
            initialShowMenu={showMenu}
            options={options}
            value={value}
            onChange={this.onDropdownChange}
            onToggleMenu={this.setEnabled}
            title={this.props.title}
            backText={this.props.backText}
            useParentWidth={this.props.useParentWidth}
            style={this.props.style}
            showArrow={false}
            allowSearch={this.props.allowSearch}
          />
        ) : (
          getStaticDropdown(selectedOption, centerLabel)
        )}
        <FormButton
          label="Change"
          disabled={isEnabled}
          onClick={this.onButtonClick}
          linkStyle={true}
          pulse={this.props.pulse}
        />
      </div>
    );
  }
}

FormEnableDropdown.propTypes = {
  disabled: PropTypes.bool,

  // Dropdown props
  options: PropTypeShapes.listOptionArray.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  centerLabel: PropTypes.bool,
  title: PropTypes.string,
  backText: PropTypes.string,
  useParentWidth: PropTypes.bool,
  style: PropTypes.object,
  onToggleMenu: PropTypes.func,
  pulse: PropTypes.bool,
  allowSearch: PropTypes.bool
};

export default FormEnableDropdown;
